module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('vbl-page', {
    attrs: {
      "total": 700
    }
  })], 1), _c('br'), _c('br'), _vm._v("\n    设置当前页\n    "), _c('div', [_c('vbl-page', {
    attrs: {
      "total": 700,
      "current": _vm.current
    },
    on: {
      "update:current": function($event) {
        _vm.current = $event
      }
    }
  })], 1), _c('br'), _c('br'), _vm._v("\n    设置每页条数\n    "), _c('div', [_c('vbl-page', {
    attrs: {
      "total": 700,
      "per-page": _vm.perPage
    },
    on: {
      "update:perPage": function($event) {
        _vm.perPage = $event
      }
    }
  })], 1), _c('br'), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c6904f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblPage/example/vblPageExample.vue
// module id = 250
// module chunks = 0